module.exports = __webpack_public_path__ + "/images/ico-share.89b4540.svg";